export default __webpack_public_path__ + "static/media/gallery-wip-pommel-neck_00.d3663249.jpg";